import React from 'react';
import classNames from 'classnames';
import proptypes from 'prop-types';
const { shape, string, number } = proptypes;

import { Button } from '@thd-olt-component-react/core-ui';

import './store-row.scss';

const setUserLocalStore = ({ id }) => {
  const localizerRequest = {
    storeId: id,
    localizationMethod: 'change store overlay'
  };

  // eslint-disable-next-line no-unused-expressions
  window?.THD_LOCALIZER_AUTO_INIT?.Localizer.localize(localizerRequest)
    .then(() => {
      const urlParams = new URLSearchParams(window?.location?.search);
      if (urlParams.has('URL')) {
        let redirectURL = urlParams.get('URL');
        if (redirectURL !== '') {
          redirectURL = decodeURIComponent(redirectURL).replace(/amp;/g, '');
          window.location = redirectURL;
        }
      } else {
        window.location.href = window?.location.href.replace(/#overlay/gm, '');
      }

    })
    .catch((error) => { /* TODO document why this arrow function is empty */ });
};

export const StoreRow = ({ clientStore, index, store }) => {
  const {
    availableQty,
    name,
    phone,
    storeId,
    address: { street, city, state, postalCode },
    toolRentalPhone,
    distance
  } = store;

  const isAvailable = availableQty && availableQty > 0;

  const availabilityClass = classNames(isAvailable ? 'available' : 'unavailable');

  const formattedDistance = Number(distance).toFixed(2);

  return (
    <div
      className={classNames(
        'store-row',
        `store-row__${index % 2 === 0 ? 'odd' : 'even'}`
      )}
    >
      <div className={classNames('store-row__col', 'store-row__col-sm')}>
        <div className="availability">
          <div
            className={classNames(
              `availability__${availabilityClass}`,
              'availability__qty-box',
              `availability__qty-box-${availabilityClass}`
            )}
          >
            {availableQty || 0}
          </div>
          <div className={classNames(`availability__${availabilityClass}`)}>
            Available
          </div>
        </div>
        <div className="distance">
          {
            (clientStore && clientStore.storeId === store.storeId) ? (
              <div>Your store {formattedDistance} miles away</div>
            ) : (
              <div>{formattedDistance} miles away</div>
            )
          }
        </div>
      </div>

      <div className={classNames('store-row__col', 'store-row__col-md')}>
        <div className="store">
          <div className="store__name">
            {name} #{storeId}
          </div>
          <div className="store__address">
            {street}, {city}, {state} {postalCode}
            <div className="store__phone-number" data-testid="phone-number">
              <b>
                | {toolRentalPhone ? 'Rental:' : 'Phone:'}
              </b>
              &nbsp;{toolRentalPhone || phone}
            </div>
          </div>
        </div>
      </div>

      <div className={classNames('store-row__col', 'store-row__col-sm')}>
        <Button small onClick={() => setUserLocalStore({ id: storeId })}>Select this Store</Button>
      </div>
    </div>
  );
};

StoreRow.propTypes = {
  clientStore: shape({}).isRequired,
  index: number,
  store: shape({
    distance: string,
    storeName: string,
    storeId: string,
    toolRentalPhone: string,
    address: shape({
      city: string,
      postalCode: string,
      state: string,
      street: string
    })
  }).isRequired
};

StoreRow.defaultProps = {
  index: undefined
};